import { css } from '@emotion/react'

import { Radio } from '@/component/molecules/Radio'
import TabItem from '@/component/molecules/SubTab/TabItem.tsx'
import type { DefaultProps } from '@/types'

import { S } from './SubTab.style.ts'

type Props = {
  value: string
  onChangeTab: (value: string) => void
  rounded?: boolean
} & DefaultProps

const SubTab = ({ value, onChangeTab, children, className, rounded = false }: Props) => {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChangeTab(e.target.value)}
      className={className}
      css={
        rounded &&
        css`
          > div {
            border-radius: var(--Radius-Circle);
          }
        `
      }
    >
      <S.Container>{children}</S.Container>
    </Radio.Group>
  )
}

export default SubTab

SubTab.Item = TabItem
